import { useQuery } from 'react-query';
import { queryKeys } from '../../services/query-key/query-keys';
import { getPrivateApi } from '../../services/api';
import { USE_CACHE_HEADER } from '../../services/api/cache-headers';
import {
  GetInvoicesBreakdownStatsResponse,
  GetInvoicesBreakdownStatsResponseSchema,
} from '@vy/api-definition';
import { Period } from '@vy/types';
import { UseQueryOptions } from 'react-query';

export function useInvoicesBreakdownStats(
  period?: Period,
  options?: UseQueryOptions<GetInvoicesBreakdownStatsResponse>,
) {
  return useQuery({
    queryKey: queryKeys.invoicesBreakdownStats(period),
    queryFn: async () => {
      const api = getPrivateApi();
      const dateRangeFilter = period ?? {};
      const getInvoicesBreakdownStatsResponse = await api.getInvoicesBreakdownStats(
        dateRangeFilter,
        USE_CACHE_HEADER,
      );

      return GetInvoicesBreakdownStatsResponseSchema.parse(getInvoicesBreakdownStatsResponse);
    },
    ...options,
  });
}
